
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 21 21","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.485 10.636c0-.65-.059-1.275-.167-1.875h-8.633v3.55h4.933a4.227 4.227 0 01-1.842 2.759v2.308h2.975c1.734-1.6 2.734-3.95 2.734-6.742z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M10.686 19.595c2.475 0 4.55-.816 6.067-2.216l-2.975-2.309c-.817.55-1.858.883-3.092.883-2.383 0-4.408-1.608-5.133-3.774h-3.05v2.366c1.508 2.992 4.6 5.05 8.183 5.05z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M5.553 12.17a5.493 5.493 0 01-.292-1.742c0-.608.109-1.191.292-1.741V6.32h-3.05a9.054 9.054 0 00-.983 4.108c0 1.484.358 2.875.983 4.109l2.375-1.85.675-.517z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M10.686 4.912c1.35 0 2.55.467 3.509 1.367l2.625-2.625c-1.592-1.483-3.659-2.392-6.134-2.392-3.583 0-6.675 2.059-8.183 5.059l3.05 2.366c.725-2.166 2.75-3.775 5.133-3.775z","fill":"currentColor"}})])
          )
        }
      }
    